import React, { FC } from 'react';
import { useHistory } from 'react-router-dom';

import AssetsSellingInfoForm from '../../../components/forms/assets-selling-info-form';
import SellingInfoContainer from '../../../containers/selling-info-container';
import AppPageMain from '../../../modules/app-page/app-page--main';
import PageHeader from '../../../modules/page-header';
import TableHeaderWrapper from '../../../modules/table-header-wrapper/table-header-wrapper';
import TableWrapper from '../../../modules/table-wrapper/table-wrapper';

const AssetsInfoPage: FC = () => {
  const history = useHistory();
  const isHistory = history.location.state?.isHistory;

  return (
    <AppPageMain>
      <div className="container">
        <div className="row">
          <div className="col-19 col-lg-27 col-xl-35">
            <PageHeader
              items={[
                { link: '/assets', title: 'Активы' },
                { link: '#', title: 'Денежные требования' },
              ]}
              iconType="assets"
            />
          </div>
        </div>
        <div className="row">
          <div className="col-19 col-lg-27 col-xl-35">
            <TableWrapper>
              <div className="ucp">
                <div className="ucp__header">
                  <TableHeaderWrapper
                    leftContent="Продажа цифровых финансовых активов"
                    onCloseClick={() =>
                      history.replace(isHistory ? '/history' : '/assets')
                    }
                  />
                </div>
                <div className="ucp__body">
                  <AssetsSellingInfoForm />
                  <div className="ucp__right ucp__right--dynamic">
                    <SellingInfoContainer />
                  </div>
                </div>
              </div>
            </TableWrapper>
          </div>
        </div>
      </div>
    </AppPageMain>
  );
};

export default AssetsInfoPage;
